import React from 'react';
import type { Environment } from './environment';

export type EnvironmentContextValue = [
  Environment | undefined,
  Environment[] | null | undefined,
];

export const EnvironmentContext = React.createContext<EnvironmentContextValue>([undefined, []]);
